import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  menu: {
    position: 'absolute',
    left: 0,
    bottom: 35,
    padding: ['8px 10.6666667vw', '8px 10.6666667vw', '8px 8.33333333vw', '8px 8.33333333vw', '8px 10.7638889vw', '8px 10.7638889vw', '8px 10.15625vw'],
    display: 'flex',
    overflowX: ['scroll', 'scroll', 'scroll', 'scroll', 'hidden'],
    overflowY: 'visible',
    maxWidth: '100%',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  menuItem: (isActive = false) => ({
    background: 'none',
    border: 'none',
    padding: '10px 6px',
    color: theme.rawColors.neutralWhite,
    borderBottom: isActive ? `solid 1px ${theme.rawColors.neutralWhite} !important` : 'solid 1px transparent',
    mr: ['24px', '24px', '24px', '24px', '40px'],
    pb: '3px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    borderRadius: 2,
    ...reusables.mainTransition(' border-color', theme.transitions.animation.atomCurve, theme.transitions.time.fast),
    '&:hover': {
      borderBottom: `solid 1px ${theme.rawColors.neutralWhite}`,
      cursor: 'pointer'
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.rawColors.blue500}`,
      outlineOffset: 0
    }
  })
};